import { useContext, useState } from "react";
import TrainingContext from "../../../context/FormacionDesarollo/TrainingContext";
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckPermission from "../../../helpers/Administradores/Permissions";
import { openKardexModal } from "../../../context/FormacionDesarollo/TrainingActions";

const MenuList = (props: any) => {
  const { state, dispatch } = useContext(TrainingContext);
  const [seeDetails, setSeeDetails] = useState<any>(null);
  const open = Boolean(seeDetails);

  const seeInformation = (id: any) => {
    setSeeDetails(null)
    openKardexModal(id, true, dispatch)
  };
  return (
    <>
      <Tooltip title="Opciones" placement="right">
        <Box className="IconButtonPoints" mr={2}>
          <IconButton onClick={(e) => setSeeDetails(e.currentTarget)}>
            <MoreVertIcon style={{ color: "#fabb00" }} />
          </IconButton>
        </Box>
      </Tooltip>
      <Menu
        className="MoreVerIcon"
        anchorEl={seeDetails}
        open={open}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={() => setSeeDetails(null)}
      >
        {CheckPermission("FormacionDesarrollo.Training.Ver") && (
          <MenuItem button onClick={() => seeInformation(props.id)}>
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Ver</span>
            </div>
            <div>
              <VisibilityIcon className="iconoMenuViewCourse" />
            </div>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
export default MenuList;
